import React from 'react';

import { setSignInStep, SignInStep } from 'prequalificationV2/actions';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import useAppNavigate from 'hooks/useAppNavigate';
import { SignInImage } from 'assets/icons';

import styles from './SignInButton.module.scss';

const SignInButton = () => {
  const dispatch = useAppDispatch();
  const navigator = useAppNavigate();

  const handleLogin = async () => {
    dispatch(setSignInStep(SignInStep.SignIn));
    navigator(AppRoutes.Login);
  };

  return (
    <div onClick={handleLogin} className={styles.logInButton}>
      <div className={styles.signInIcon}>
        <SignInImage />
      </div>
      <div>Log in</div>
    </div>
  );
};

export default SignInButton;
